<template>
  <div>
    <el-card>
      <div style="font-size: 14px; color: #606266;">
        <span>No：{{ formData.quotationNo }}</span>
        <el-divider direction="vertical"></el-divider>
        <span
          >Status：{{
            formData.quotationStatus === 'Y'
              ? $l('tips_quotedPrice') || '已报价'
              : $l('tips_add') || '新增'
          }}</span
        >
        <el-divider direction="vertical"></el-divider>
        <span
          >Create：{{ formData.createByName }} at
          {{ formData.createDate }}</span
        >
        <el-divider direction="vertical"></el-divider>
        <span
          >Modify：{{ formData.modifyByName }} at
          {{ formData.modifyDate }}</span
        >
      </div>
      <div class="d2-mt">
        <el-form ref="form" :model="formData">
          <el-row :gutter="20">
            <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :xl="{ span: 6 }">
              <el-form-item
                :label="$l('form_label_quotationDate') || '报价日期'"
                prop="quotationDate"
              >
                <el-date-picker
                  v-model="formData.quotationDate"
                  type="date"
                  :placeholder="
                    $l('INDEX.tips_select_data') || '请选择报价日期'
                  "
                  value-format="yyyy-MM-dd"
                  size="medium"
                  :disabled="isViewDisabled"
                  style="width:100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :xl="{ span: 6 }">
              <el-form-item
                :label="$l('form_label_closingDate') || '截止日期'"
                prop="quotationExpiryDate"
              >
                <el-date-picker
                  v-model="formData.quotationExpiryDate"
                  type="date"
                  :placeholder="
                    $l('INDEX.tips_select_data') || '请选择截止日期'
                  "
                  value-format="yyyy-MM-dd"
                  size="medium"
                  :disabled="isViewDisabled"
                  style="width:100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :xl="{ span: 6 }">
              <el-form-item
                :label="$l('form_label_quotationStatus') || '报价单状态'"
              >
                <el-select
                  v-model="formData.quotationStatus"
                  clearable
                  filterable
                  :disabled="isViewDisabled"
                  size="medium"
                  style="width:100%;"
                >
                  <el-option
                    value="Y"
                    :label="$l('tips_quotedPrice') || '已报价'"
                  />
                  <el-option value="N" :label="$l('tips_add') || '新增'" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :xl="{ span: 6 }">
              <el-form-item
                :label="$l('form_label_quotationNo') || '报价单编号'"
                prop="quotationNo"
              >
                <el-input
                  v-model="formData.quotationNo"
                  :placeholder="
                    $l('INDEX.tips_placeholder_generatedBySystem') ||
                      '由系统生成'
                  "
                  disabled
                  clearable
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :xl="{ span: 6 }">
              <el-form-item
                :label="$l('form_label_customerName') || '客户名称'"
                prop="custName"
              >
                <el-input
                  v-model="formData.custName"
                  :placeholder="
                    $l('INDEX.tips_placeholder_generatedBySystem') ||
                      '由系统生成'
                  "
                  disabled
                  clearable
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :xl="{ span: 6 }">
              <el-form-item
                :label="
                  $l('form_label_correspondingProjectName') || '对应项目名称'
                "
                prop="prjTitle"
              >
                <el-input
                  v-model="formData.prjTitle"
                  disabled
                  clearable
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :xl="{ span: 6 }">
              <el-form-item
                :label="$l('form_label_currentVersionNumber') || '当前版本号'"
                prop="versionNumber"
              >
                <el-input
                  v-model="formData.versionNumber"
                  :placeholder="
                    $l('INDEX.tips_placeholder_generatedBySystem') ||
                      '由系统生成'
                  "
                  disabled
                  clearable
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :xl="{ span: 6 }">
              <el-form-item
                :label="$l('form_label_nameOfCreator') || '创建人名称'"
                prop="createByName"
              >
                <el-input
                  v-model="formData.createByName"
                  :placeholder="
                    $l('INDEX.tips_placeholder_generatedBySystem') ||
                      '由系统生成'
                  "
                  disabled
                  clearable
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :xl="{ span: 6 }">
              <el-form-item
                :label="$l('form_label_creationTime') || '创建时间'"
                prop="createDate"
              >
                <el-input
                  v-model="formData.createDate"
                  :placeholder="
                    $l('INDEX.tips_placeholder_generatedBySystem') ||
                      '由系统生成'
                  "
                  disabled
                  clearable
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :xl="{ span: 6 }">
              <el-form-item
                :label="$l('form_label_modifiedBy') || '修改人'"
                prop="modifyByName"
              >
                <el-input
                  v-model="formData.modifyByName"
                  :placeholder="
                    $l('INDEX.tips_placeholder_generatedBySystem') ||
                      '由系统生成'
                  "
                  disabled
                  clearable
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :xl="{ span: 6 }">
              <el-form-item
                :label="$l('form_label_modificationTime') || '修改时间'"
                prop="modifyByName"
              >
                <el-input
                  v-model="formData.modifyDate"
                  :placeholder="
                    $l('INDEX.tips_placeholder_generatedBySystem') ||
                      '由系统生成'
                  "
                  disabled
                  clearable
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="d2-mt">
        <item
          ref="item"
          :params="itemParams"
          :autoLoad="true"
          :isViewDisabled="isViewDisabled"
        />
      </div>
      <div class="d2-mt">
        <el-row>
          <el-col :span="24">
            <el-button
              @click="save"
              type="primary"
              size="small"
              v-if="!isViewDisabled"
              >{{ $l('INDEX.btn_save') || '保存' }}</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>
<script>
import Item from './components/item'
import { mapActions } from 'vuex'
export default {
  components: {
    Item,
  },
  data() {
    return {
      activeName: 'info',
      pageHeader: '',
      isViewDisabled: false,
      dialogVisible: false,
      formData: {
        quotationCode: '',
        quotationNo: '',
        custCode: '',
        custName: '',
        prjCode: '',
        prjTitle: '',
        quotationDate: '',
        quotationExpiryDate: '',
        quotationStatus: '',
        quotationStatusName: '',
        createBy: '',
        createByName: '',
        createDate: '',
        modifyBy: '',
        modifyByName: '',
        modifyDate: 'Y',
        versionNumber: '',
      },
    }
  },
  mounted() {
    if (this.$route.params.pageType && this.$route.params.quotationCode) {
      this.formLoad()
    }
  },
  // 侦听器
  watch: {
    '$route.params'() {
      if (this.$route.params.pageType && this.$route.params.quotationCode) {
        this.formLoad()
      }
    },
  },
  computed: {
    itemParams() {
      return {
        quotationCode: this.$route.params.quotationCode,
        quotationNo: this.formData.quotationNo,
        custName: this.formData.custName,
      }
    },
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    formLoad() {
      // this.formData = this.$route.params.tableRow
      let pageType = this.$route.params.pageType
      this.loadDetail(this.$route.params.quotationCode)
      if (pageType === 'detail') {
        this.pageHeader = this.$l('page_detail') || '客户报价单详情'
        this.isViewDisabled = true
      } else {
        this.isViewDisabled = false
        this.pageHeader = this.$l('page_edit') || '客户报价单修改'
      }
    },
    loadDetail(quotationCode) {
      let param = { quotationCode: quotationCode }
      this.$api.myQuotationDetailApi(param).then((res) => {
        this.formData = res.body
      })
    },
    save() {
      this.$api.myQuotationMainSaveApi(this.formData).then((res) => {
        this.reset()
        this.saveOkQuestion()
      })
    },
    saveOkQuestion() {
      this.$alert(
        this.$l('INDEX.tips_save_ok') || '保存成功',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          confirmButtonText: '确定',
          callback: () => {
            this.closeCurPage()
          },
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    reset() {
      this.activeName = 'info'
      this.isViewDisabled = false
      this.dialogVisible = false
    },
  },
}
</script>
